import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";

const CityDetailsModal = ({
  selectedCity,
  setSelectedCity,
  openDetailsModal,
  setOpenDetailsModal,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedCity({});
    setOpenDetailsModal(false);
  };

  return (
    <Modal
      show={openDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
      data-testid="modal"
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>City Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          {Object.entries({
            "City Name": selectedCity?.city_name || "",
            "Province Name": selectedCity?.province?.province_name || "",
            "Country Name": selectedCity?.country?.country_name || "",
            Status: selectedCity?.status ? "Active" : "In Active",
            "Created At": selectedCity?.createdAt
              ? format(selectedCity?.createdAt, "PP")
              : "",
            "Updated At": selectedCity?.updatedAt
              ? format(selectedCity?.updatedAt, "PP")
              : "",
            "Deleted At": selectedCity?.deletedAt
              ? format(selectedCity?.deletedAt, "PP")
              : "",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span
                  className={`d-block fs-5 fw-medium ${!value && "text-danger"}`}
                >
                  {value || "N/A"}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default CityDetailsModal;
